import FlatsAndHousesToRent from "./FlatsAndHousesToRent";

export default FlatsAndHousesToRent;
